<template>
    <div class="block">
        <span class="input-name" v-if="showInputTitle">{{inputTitle}}</span>
        <el-date-picker
            class="el-calendar-input"
            popper-class="el-picker"
            v-model="checkDate"
            type="date"
            :value-format="format"
            :placeholder="showInputTitle?'':placeholder"
            :picker-options="pickerOptions"
            :append-to-body="false"
            :clearable="false"
            :editable="false"
            @blur="showInputTitle=false;"
            @focus="showInputTitle=true;"
            size="mini">
        </el-date-picker>
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                type: Number,String
            },
            placeholder: {
                type: String
            },
            inputTitle: {
                type: String
            },
            format: {
                type: String
            },
            default: () => []
        },
        watch: {
            checkDate(val) {
                this.$emit('input', val);
            },
        },
        data() {
            return {
                checkDate: this.value,
                pickerOptions: {
                    disabledDate (time) {
                        return time.getTime() > Date.now() - 8.64e6;
                    }
                },
                showInputTitle: false,//日期输入框展示
            };
        },
    };
</script>

<style>
.block {
    width: 140px;/*no*/
    position: relative;
}

.el-calendar-input {
    width: fit-content !important;
    font-size: 14px;/*no*/
    font-family: Arial;
    font-weight: 400;
    line-height: 21px;/*no*/
}

.el-input--prefix .el-input__inner {
    height: 40px;/*no*/
    text-align: center;
    margin-top: 0;
}
.el-input--prefix .el-input__inner::-webkit-input-placeholder { /* Chrome/Opera/Safari */
    color: #000000;
}
.el-input--prefix .el-input__inner:-ms-input-placeholder { /* IE 10+ */
    color: #000000;
}
.el-input--prefix .el-input__inner:-moz-placeholder { /* Firefox 18- */
    color: #000000;
    opacity: 1;
}
.el-input--prefix .el-input__inner::-moz-placeholder { /* Firefox 19+ */
    color: #000000;
    opacity: 1;
}

.el-input.is-active .el-input__inner, .el-input__inner:focus {
    border: 1px solid #8A96E3;
}

.el-picker-panel__icon-btn {
    margin-top: 0;
}

.el-picker-panel__icon-btn:hover {
    color: #5065BB;
    background: #E8ECFA;
}

.el-date-picker .el-picker-panel__content {
    text-align: center;
}
.el-date-table td.current:not(.disabled) span{
    background: #5065BB;
}

.el-icon-date {
    display: none;
}

.el-date-picker__header-label {
    font-weight: bold;
}

.el-date-picker__header-label.active, .el-date-picker__header-label:hover {
    color: #5065BB;
}

.el-date-table td.today span {
    color: #5065BB;
    background: #E3E6F3;
}

.input-name{
    font-size: 12px;
    font-family: Arial;
    font-weight: 400;
    line-height: 21px;
    color: #8A96E3;
    position: absolute;
    top: -10px;
    left: 8px;
    z-index: 100;
    padding: 0 2px;
    background: #ffffff;
}
</style>


// WEBPACK FOOTER //
// src/components/common/calendar/calendar.vue